<app-applicant-funnel-message-dialog
    [subject]="droppedApplicantJobFunnelMessageTemplate?.subject"
    [openDialog]="isChangeFunnelStageModalOpen"
    (confirmChangeFunnelStage)="onConfirmChangeFunnelStage()"
    (closeChangeFunnelStage)="onCloseChangeFunnelStage()"
>
</app-applicant-funnel-message-dialog>

<ui-dialog
    size="small"
    [open]="isOpenAddFunnel"
    header="{{ 'applicant-tracker.addFunnelStage' | translate }}"
    (closing)="closeAddFunnelModal()"
    #addColumnModal
    *ngIf="canAccessTemplates"
>
    <form #form="ngForm" autocomplete="off" class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label>{{ 'applicant-tracker.columnName' | translate }}</mat-label>
            <input type="text" required matInput #column="ngModel" name="column" [(ngModel)]="temporaryColumnName" />
            <mat-error *ngIf="column.invalid">{{ column.errors | formErrors }}</mat-error>
        </mat-form-field>
    </form>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeAddFunnelModal()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onColumnAdded()">{{ 'save' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isOpenApplyTemplate"
    header="{{ 'applicant-tracker.applyTemplate' | translate }}"
    (closing)="closeApplyTemplateModal()"
    *ngIf="canAccessTemplates"
>
    <ui-banner *ngIf="selectedFunnelTemplate?.hasEmailAutomation" variant="info" class="margin-bottom-3"
        >{{ 'applicant-tracker.thisTemplateHasAutomatedEmailsConfigured' | translate }}
    </ui-banner>
    <mat-form-field>
        <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.selectTemplate' | translate }}</mat-label>
        <mat-select
            [(ngModel)]="selectedFunnelTemplate"
            name="funnelTemplate"
            placeholder="{{ 'applicant-tracker.selectTemplate' | translate }}"
            [formControl]="funnelTemplateControl"
            required
        >
            <mat-option *ngFor="let funnelTemplate of funnelTemplates" [value]="funnelTemplate">{{
                funnelTemplate.name
            }}</mat-option>
        </mat-select>
        <mat-error *ngIf="funnelTemplateControl.invalid">{{ funnelTemplateControl.errors | formErrors }}</mat-error>
    </mat-form-field>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeApplyTemplateModal()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSaveApplyTemplate()">{{ 'applicant-tracker.open' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<ui-dialog
    size="small"
    [open]="isOpenSaveTemplate"
    header="{{ 'applicant-tracker.saveTemplate' | translate }}"
    (closing)="closeSaveTemplateModal()"
    *ngIf="canAccessTemplates"
>
    <app-funnel-template-form
        [funnelStageAndMessageTemplates]="funnelStageAndMessageTemplates"
        [funnelTemplate]="temporaryFunnelTemplate"
        [temporaryDelete]="true"
    ></app-funnel-template-form>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeSaveTemplateModal()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="onSaveFunnelTemplate()">{{ 'save' | translate }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="ui basic segment scroll" [class.loading]="isLoading">
    <app-job-posting-header
        [jobPosting]="jobPosting"
        (onChangePause)="onPause($event)"
        [showApplicantMessagingButton]="true"
    ></app-job-posting-header>
    <div class="flex options-panel">
        <ng-container *ngIf="canAccessTemplates">
            <ui-button
                class="apply-button"
                [matMenu]="applyDropdown"
                (menuClosed)="expandApplyDropdown = false"
                (menuOpened)="expandApplyDropdown = true"
                >{{ 'applicant-tracker.templates' | translate }}
                <mat-icon *ngIf="!expandApplyDropdown" svgIcon="chevronDown"></mat-icon>
                <mat-icon *ngIf="expandApplyDropdown" svgIcon="chevronUp"></mat-icon>
            </ui-button>
            <!-- Mat menu -->
            <mat-menu #applyDropdown xPosition="before">
                <button mat-menu-item (click)="openSaveFunnelTemplate()">
                    {{ 'applicant-tracker.saveAsTemplate' | translate }}
                </button>
                <button mat-menu-item (click)="applyFunnelTemplate()">
                    {{ 'applicant-tracker.applyTemplate' | translate }}
                </button>
            </mat-menu>

            <ui-button type="outline" (click)="onAddColumn()"
                ><mat-icon svgIcon="plus"></mat-icon>{{ 'applicant-tracker.addStage' | translate }}</ui-button
            >
        </ng-container>
    </div>
    <app-kanban
        *ngIf="kanban"
        [isEmailAutomationForJobFunnel]="this.canAccessTemplates"
        [columns]="kanban"
        [allowColumnCreation]="true"
        [allowColumnDeletion]="true"
        [allowColumnRename]="true"
        (columnOrderChanged)="funnelService.updateColumnOrder($event, jobPosting); onColumnOrderChanged($event)"
        (columnDeleted)="onColumnDeleted($event)"
        (columnNameUpdated)="funnelService.updateColumnName($event, jobPosting)"
        (cardDropped)="onCardDropped($event)"
        (applicantOrderChanged)="funnelService.updateApplicantOrder($event)"
    ></app-kanban>
</div>
